const walk = (string, replacements) => {
    let result = string
    for (let key in replacements) {
        result = result.replace(replacements[key], key)
    }
    return result
}

export const standardize = (str) => walk(str, special)

export function substitute(str, object, regexp) {
    return String(str).replace(regexp || /\\?\{([^{}]+)\}/g, function (match, name) {
        if (match.charAt(0) == '\\') return match.slice(1)
        if (object[name] === undefined) return match
        return object[name] != null ? object[name] : ''
    })
}

export function replaceAt(inputString, index, replacement) {
    return inputString.substr(0, index) + replacement + inputString.substr(index + replacement.length)
}

export function humanFileSize(bytes, si = false, dp = 1) {
    const thresh = si ? 1000 : 1024

    if (Math.abs(bytes) < thresh) {
        return bytes + ' B'
    }

    const units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
    let u = -1
    const r = 10 ** dp

    do {
        bytes /= thresh
        ++u
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1)

    return bytes.toFixed(dp) + ' ' + units[u]
}
